import React, { useEffect, useRef } from "react";

interface Coordinate {
  lat: number;
  lng: number;
  count: number;
}

const google = window.google || {};

interface GoogleMapProps {
  coordinates: Coordinate[];
}

function GoogleMap({ coordinates }: GoogleMapProps) {
  const mapRef = useRef<HTMLDivElement>(null);
  const markers = useRef<google.maps.Marker[]>([]);
  const line = useRef<google.maps.Polyline | null>(null);

  useEffect(() => {
    // Create the map instance
    const mapOptions: google.maps.MapOptions = {
      zoom: 3,
      center: { lat: -21.7704448, lng: -77.8085917 },
      // center: { lat:-21.7704448, lng:-77.8085917} // Use the first coordinate as the initial map center
    };
    const map = new google.maps.Map(mapRef.current!, mapOptions);

    // Create markers for each coordinate
    coordinates.forEach((coordinate, index) => {
      if (coordinate.lat === 0 || coordinate.lng === 0) return;
      const marker = new google.maps.Marker({
        position: coordinate,
        map: map,
        label: coordinate.count.toString(), // Use a label with the marker's index
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          fillColor: "#26ff00", // Set the pin color here
          fillOpacity: 1,
          strokeWeight: 0,
          scale: 20,
        },
      });
      markers.current.push(marker);
    });

    //Draw lines between coordinates
    const lineCoordinates: google.maps.LatLngLiteral[] = coordinates.map(
      (coordinate) => ({
        lat: coordinate.lat,
        lng: coordinate.lng,
      })
    );
    // const polyline = new google.maps.Polyline({
    //   path: lineCoordinates,
    //   geodesic: true,
    //   strokeColor: '#26ff00', // Red color for the line
    //   strokeOpacity: 1.0,
    //   strokeWeight: 2,
    // });
    // line.current = polyline;
    // polyline.setMap(map);

    // Clean up the markers and line on unmount
    return () => {
      markers.current.forEach((marker) => marker.setMap(null));
      markers.current = [];
      if (line.current) {
        line.current.setMap(null);
      }
    };
  }, [coordinates]);

  return <div ref={mapRef} style={{ width: "100%", height: "500px" }} />;
}

export default GoogleMap;
